import { clsx } from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Header = function Header(_ref) {
  var header = _ref.header;
  var title = header.title,
    icon = header.icon,
    _header$accentedColor = header.accentedColor,
    accentedColor = _header$accentedColor === void 0 ? true : _header$accentedColor;
  if (!title && Boolean(icon)) return null;
  var Icon = header.icon;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx('tw-flex tw-pt-2 tw-pb-1.6 tw-px-1.2 tw-items-center tw-border-t tw-border-solid dark:tw-border-neutral-dark-700 tw-border-neutral-light-300'),
    children: [/*#__PURE__*/_jsx("div", {
      className: "tw-w-[40px] tw-h-[40px] tw-rounded-[6px] tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-01 tw-flex tw-items-center tw-justify-center tw-border-solid tw-border-[0.5px] dark:tw-border-elevation-dark-04  tw-border-neutral-light-400 ",
      children: /*#__PURE__*/_jsx(Icon, {
        size: 24,
        className: clsx(accentedColor ? 'tw-text-primary-light-500 dark:tw-text-neutral-dark-500' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500')
      })
    }), /*#__PURE__*/_jsx("p", {
      className: "tw-font-subtitle4 tw-text-neutral-light-800 dark:tw-text-neutral-dark-400 tw-ml-1.2",
      children: header.title
    })]
  });
};
export default Header;